// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EddI-","containerContent":"styles_containerContent__p0Y7g"};